<template>
  <div class="px-5">
    <Tabbar />

    <div class="d-flex my-4">
      <select
        name=""
        id=""
        v-model="sort"
        class="p-1 mr-1 form-select px-3 border mr-3"
        @change="getPackages()"
      >
        <option value="updated_at">Ngày cập nhật</option>
        <option value="created_at">Ngày tạo</option>
      </select>
      <select
        name=""
        id=""
        v-model="sort_by"
        class="p-1 form-select px-3 border mr-3"
        @change="getPackages()"
      >
        <option value="desc">Mới nhất trước</option>
        <option value="asc">Cũ nhất trước</option>
      </select>
          <button
            class="input-group-text btn btn-l btn-primary"
            @click="showAdd(true)"
          >Thêm mới +</button>
    </div>
    <div>
      <div class="table-responsive">
        <table class="table table-vcenter table-mobile-md card-table">
          <thead>
            <tr>
              <th>Tên gói</th>
              <th>Code</th>
              <th>Giá mỗi tháng</th>
              <th>Key</th>
              <th>Mô tả</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="pack in packages.data"
              :key="pack.id"
            >
              <td data-label="Tên gói">
                {{pack.name}}
              </td>
              <td data-label="Code">
                {{pack.code}}
              </td>
              <td data-label="Giá mỗi tháng">
                {{pack.price_per_month}}
              </td>
              <td data-label="Key">
                {{pack.key}}
              </td>
              <td data-label="Mô tả">
                {{pack.description}}
              </td>
              <td>

                <button
                  class="btn bg-pri bd-pri text-white mt-1 mr-2"
                  @click="update(pack)"
                >Chỉnh sửa</button>
                <button
                  class="btn mt-1"
                  :class="!pack.status ? 'bg-pri bd-pri text-white' : 'btn-white'"
                  @click="changeStatusPack(pack)"
                >{{pack.status ? 'Inactive' : 'Active'}}</button>
              </td>
            </tr>
          </tbody>
          <tbody
            v-if="loading"
            class="h-100"
            style="min-height: 600px;"
          >
            <tr>
              <td
                colspan="6"
                class="text-center py-5"
              >
                <div
                  class="spinner-border"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <ModalUpdatePack
      @onUpdate="onUpdate"
      :edit="edit"
    />
    <ModalCreatePack @onCreate="onCreate" />
  </div>
</template>

<script>
import Tabbar from '../../../components/Cms/Members/Tabbar.vue'
import ModalCreatePack from '../../../components/Cms/Members/Packages/ModalCreatePack.vue'
import ModalUpdatePack from '../../../components/Cms/Members/Packages/ModalUpdatePack.vue'
export default {
  name: 'PackagesManagement',
  components: { Tabbar, ModalCreatePack, ModalUpdatePack },
  data () {
    return {
      packages: [],
      loading: false,
      search: '',
      sort: 'created_at',
      sort_by: 'desc',
      page: 1,
      edit: null
    }
  },
  mounted () {
    let self = this
    self.getPackages()
  },
  methods: {
    async getPackages () {
      let self = this
      self.loading = true
      try {
        self.page = parseInt(self.$route.query.page) || 1
        let params = {
          limit: 10,
          search: self.search,
          sort: self.sort || 'created_at',
          sort_by: self.sort_by || 'desc',
          page: self.page
        }
        await self.$rf.getRequest('AdminRequest').getPackages(params).then(res => {
          self.packages = res.data || []
        })
      } catch (e) {
        // statements
        console.log(e)
      } finally {
        self.loading = false
      }
    },
    onSearch () {
      let self = this
      self.getPackages()
    },
    onSearchDelete () {
      let self = this
      if (self.search.length === 0) {
        self.getPackages()
      }
    },
    async onCreate (data) {
      let self = this
      if (data) {
        self.loading = true
        self.$rf.getRequest('AdminRequest').createPackages(data).then((resp) => {
          self.showAdd(false)
          self.getPackages()
        }).finally(() => {
          self.loading = false
        })
      }
    },
    update (pack) {
      this.edit = pack
      this.showEdit(true)
    },
    async onUpdate (data) {
      let self = this
      if (data && self.edit) {
        self.loading = true
        self.$rf.getRequest('AdminRequest').updatePackages(self.edit.id, data).then((resp) => {
          self.edit = null
          self.showEdit(false)
          self.getPackages()
        }).finally(() => {
          self.loading = false
        })
      }
    },
    async changeStatusPack (pack) {
      let self = this
      if (pack) {
        self.loading = true
        let params = {
          code: pack.code,
          name: pack.name,
          description: pack.description,
          status: parseInt(pack.status) ? 0 : 1,
          price_per_month: pack.price_per_month
        }
        self.$rf.getRequest('AdminRequest').updatePackages(pack.id, params).then((resp) => {
          self.getPackages()
        }).finally(() => {
          self.loading = false
        })
      }
    },
    showEdit (show) {
      window.$('#ModalUpdatePack').modal(show ? 'show' : 'hide')
    },
    showAdd (show) {
      window.$('#ModalCreatePack').modal(show ? 'show' : 'hide')
    }
  }
}
</script>

<style scoped>
</style>